import { CalendarDays, CheckCircle2 } from "lucide-react";
import { isOverdue, prettyDate } from "@/lib/dates";
import { TaskCard } from "./TaskCard";
import { EmployeeChip } from "./EmployeeBadge";

const Group = ({ title, tasks, empById, h, tone, testId }) => (
  <section data-testid={testId} className="planner-surface p-4">
    <div className="mb-3 flex items-center gap-2">
      <span className="h-2.5 w-2.5 rounded-full" style={{ background: tone }} />
      <h2 className="font-display text-base font-semibold">{title}</h2>
      <span className="count-pill">{tasks.length}</span>
    </div>
    {tasks.length === 0 ? (
      <p className="text-sm text-slate-500">Nessuna attività.</p>
    ) : (
      <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
        {tasks.map((t) => (
          <TaskCard
            key={t.id}
            task={t}
            h={h}
            showAssign={!t.date}
            meta={
              t.date && (
                <>
                  <span className="inline-flex items-center gap-1"><CalendarDays className="h-3 w-3" />{prettyDate(t.date)}</span>
                  {empById[t.employee_id] && <EmployeeChip employee={empById[t.employee_id]} />}
                </>
              )
            }
          />
        ))}
      </div>
    )}
  </section>
);

export const OpenTasksView = ({ tasks, employees, employeeFilter, h }) => {
  const empById = Object.fromEntries(employees.map((e) => [e.id, e]));
  const list = tasks.filter((t) => employeeFilter === "all" || t.employee_id === employeeFilter);
  const late = list.filter(isOverdue);
  const unassigned = employeeFilter === "all" ? list.filter((t) => !t.date) : [];
  const planned = list.filter((t) => t.date && !isOverdue(t));

  if (list.length === 0 && unassigned.length === 0) {
    return (
      <div data-testid="open-tasks-empty" className="planner-surface flex flex-col items-center gap-2 py-16 text-center text-slate-500">
        <CheckCircle2 className="h-8 w-8 text-emerald-500" />
        <p className="font-display text-base font-semibold text-slate-700">Tutto completato</p>
        <p className="text-sm">Non ci sono attività aperte.</p>
      </div>
    );
  }

  return (
    <div data-testid="open-tasks-view" className="space-y-4">
      <Group testId="open-group-late" title="In ritardo" tasks={late} empById={empById} h={h} tone="#F43F5E" />
      {employeeFilter === "all" && <Group testId="open-group-unassigned" title="Da assegnare" tasks={unassigned} empById={empById} h={h} tone="#94A3B8" />}
      <Group testId="open-group-planned" title="Programmate" tasks={planned} empById={empById} h={h} tone="#10B981" />
    </div>
  );
};
